import { render, staticRenderFns } from "./EmpresasYCentros.vue?vue&type=template&id=00b6705c&scoped=true&"
import script from "./EmpresasYCentros.vue?vue&type=script&lang=js&"
export * from "./EmpresasYCentros.vue?vue&type=script&lang=js&"
import style0 from "./EmpresasYCentros.vue?vue&type=style&index=0&id=00b6705c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6705c",
  null
  
)

export default component.exports